export enum PlanningActionTypes {
  GET_PLANNINGS_PENDING = '@@sounds/GET_PLANNINGS_PENDING',
  GET_PLANNINGS_SUCCESS = '@@sounds/GET_PLANNINGS_SUCCESS',
  GET_PLANNINGS_ERROR = '@@sounds/GET_PLANNINGS_ERROR',
}
